import type React from 'react'
import type { TextBoxColors } from 'atoms/TextBox'
import type { ContainerHeaderPaddings } from '../ContainerHeader.h'

import { TextBox, TextBoxTypes, TextTransform } from 'atoms/TextBox'
import { ContainerHeader } from '../ContainerHeader'
import {
  ContainerHeaderAlignItems,
  ContainerHeaderJustifyContent,
} from '../ContainerHeader.h'
import { ContainerHeaderWithDescriptionSC } from '../ContainerHeader.styled'

export interface IContainerHeaderWithTitleDescriptionProps {
  title: string
  description?: string
  paddings?: (typeof ContainerHeaderPaddings)[keyof typeof ContainerHeaderPaddings]
  children?: React.ReactNode | null
  color?: TextBoxColors
}

export const ContainerHeaderWithTitleDescription = ({
  title,
  paddings,
  children,
  color,
  description,
}: IContainerHeaderWithTitleDescriptionProps) => {
  return (
    <ContainerHeader
      alignItems={ContainerHeaderAlignItems.Baseline}
      justifyContent={ContainerHeaderJustifyContent.SpaceBetween}
      paddings={paddings}
    >
      <ContainerHeaderWithDescriptionSC>
        <TextBox
          title={title}
          font={TextBoxTypes.FontLgBold}
          textTransform={TextTransform.None}
          color={color}
        />

        {description && (
          <TextBox
            title={description}
            font={TextBoxTypes.FontSm}
            textTransform={TextTransform.None}
            color={color}
          />
        )}
      </ContainerHeaderWithDescriptionSC>

      {children}
    </ContainerHeader>
  )
}

ContainerHeaderWithTitleDescription.displayName =
  'ContainerHeaderWithTitleDescription'
